import React from 'react';
import { cn } from '@/app/utils';

export interface TextElementCoverProps {
  /** 文字名称 */
  name?: string;
  /** 自定义样式，可覆盖 size */
  className?: string;
  /** 自定义文本样式 */
  textClassName?: string;
  /** 点击事件 */
  onClick?: () => void;
}

/**
 * 文字主体的封面组件
 */
export const TextElementCover = React.memo<TextElementCoverProps>(({ name, className, textClassName, onClick }) => {
  return (
    <div
      className={cn('relative flex size-full overflow-hidden rounded-16 bg-[#212121] p-3', className)}
      onClick={onClick}
    >
      <BackgroundSvg className="pointer-events-none absolute inset-0" width="100%" height="100%" />
      <div
        className={cn(
          'relative m-auto line-clamp-1 w-full break-words text-center font-medium text-3xl text-white [font-size:inherit]',
          textClassName,
        )}
      >
        {name?.split(/[\s-]/)[0]}
      </div>
    </div>
  );
});

TextElementCover.displayName = 'TextElementCover';

const BackgroundSvg = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="1em" height="1em" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="72" height="72" fill="#212121" />
      <g opacity="0.32" filter="url(#filter0_f_247_3720)">
        <ellipse cx="36" cy="71.7321" rx="82.5" ry="58.6607" fill="url(#paint0_radial_247_3720)" />
      </g>
      <defs>
        <filter
          id="filter0_f_247_3720"
          x="-100.071"
          y="-40.5"
          width="272.143"
          height="224.464"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur stdDeviation="26.7857" result="effect1_foregroundBlur_247_3720" />
        </filter>
        <radialGradient
          id="paint0_radial_247_3720"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(36 71.7321) rotate(90) scale(58.6607 82.5)"
        >
          <stop stopColor="#697FFF" />
          <stop offset="1" stopColor="#697FFF" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_247_3720">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
